import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

import { InvoiceDetailsView } from '../../models/invoice-extract.types';
import { getInvoiceStatusBadgeClass } from '../../../../shared/util/invoice-status.util';
import { InlineLoadingComponent } from '../../../../shared/ui/loading/inline-loading.component';
import { INVOICE_DETAILS_LOADING_KEY } from '../../services/invoice-details-sidebar.service';

interface InvoiceDetailsInfoItem {
  labelKey: string;
  value: string;
}

@Component({
  selector: 'app-invoice-details-sidebar',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatIconModule, TranslateModule, InlineLoadingComponent],
  templateUrl: './invoice-details-sidebar.component.html',
  styleUrl: './invoice-details-sidebar.component.scss',
})
export class InvoiceDetailsSidebarComponent {
  readonly data = input<InvoiceDetailsView | null>(null);

  readonly detailsLoadingKey = INVOICE_DETAILS_LOADING_KEY;

  readonly closeSidebar = output<void>();

  readonly statusBadgeClass = computed(() => getInvoiceStatusBadgeClass(this.data()?.statusCode ?? ''));

  readonly infoItems = computed<InvoiceDetailsInfoItem[]>(() => {
    const view = this.data();
    if (!view) {
      return [];
    }

    return [
      { labelKey: 'invoice_extract.details.issuance_date', value: view.invoiceIssuance },
      { labelKey: 'invoice_extract.details.due_date', value: view.dueDate },
      { labelKey: 'invoice_extract.details.payment_date', value: view.invoicePayment },
      { labelKey: 'invoice_extract.details.release_date', value: view.invoiceRelease },
      { labelKey: 'invoice_extract.details.amount', value: view.invoiceAmount },
      { labelKey: 'invoice_extract.details.approved_amount', value: view.totalValueApproved },
      { labelKey: 'invoice_extract.details.icms_value', value: view.icmsValue },
      { labelKey: 'invoice_extract.details.iss_value', value: view.issValue },
      { labelKey: 'invoice_extract.details.shipper_name', value: view.shipperCompanyName },
      { labelKey: 'invoice_extract.details.shipper_document', value: view.shipperCompanyDocument },
      { labelKey: 'invoice_extract.details.carrier_name', value: view.carrierCompanyName },
      { labelKey: 'invoice_extract.details.carrier_document', value: view.carrierCompanyDocument },
      { labelKey: 'invoice_extract.details.authorization_user', value: view.authorizationUser },
      { labelKey: 'invoice_extract.details.authorization_date', value: view.authorizationDate },
      { labelKey: 'invoice_extract.details.comment', value: view.comment },
    ];
  });

  onClose(): void {
    this.closeSidebar.emit();
  }

  trackByLabel(index: number, item: InvoiceDetailsInfoItem): string {
    return item.labelKey;
  }
}
